import {UserEntity} from "../graphql/graphQlApiHooks";


export function getFio(user: UserEntity) {
  return user?.fio || user.login
}
